var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85132 1.41892C3.85132 0.63527 4.48659 0 5.27024 0H9.7297C10.5133 0 11.1486 0.63527 11.1486 1.41892C11.1486 2.20257 10.5133 2.83784 9.7297 2.83784H5.27024C4.48659 2.83784 3.85132 2.20257 3.85132 1.41892Z",
    fill: "#6929E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.7051 1.29943C2.77629 1.28961 2.83784 1.34775 2.83784 1.41961C2.83784 2.763 3.92688 3.85204 5.27027 3.85204H9.72973C11.0732 3.85204 12.1622 2.763 12.1622 1.41961C12.1622 1.34775 12.2237 1.28961 12.2949 1.29943C13.0247 1.40009 13.6309 1.6152 14.1096 2.09436C14.5976 2.58275 14.8074 3.19764 14.9055 3.92797C15 4.6315 15 5.52605 15 6.63601V12C15 13.11 15 14.0046 14.9055 14.7081C14.8074 15.4384 14.5976 16.0533 14.1096 16.5417C13.6216 17.0302 13.0071 17.2403 12.2771 17.3386C11.5742 17.4332 10.6804 17.4332 9.57154 17.4331H5.42843C4.31961 17.4331 3.42581 17.4332 2.72283 17.3386C1.99291 17.2403 1.37837 17.0302 0.89036 16.5417C0.402414 16.0533 0.192568 15.4384 0.0944679 14.7081C-2.39707e-05 14.0046 -1.57955e-05 13.11 4.20759e-07 12.0001V6.63598C-1.57955e-05 5.52605 -2.39707e-05 4.63148 0.0944679 3.92797C0.192568 3.19764 0.402414 2.58275 0.89036 2.09436C1.36907 1.6152 1.97528 1.40009 2.7051 1.29943Z",
    fill: "#6929E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65039 7.90547C3.65039 7.56963 3.92265 7.29736 4.2585 7.29736H10.745C11.0809 7.29736 11.3531 7.56963 11.3531 7.90547C11.3531 8.24131 11.0809 8.51358 10.745 8.51358H4.2585C3.92265 8.51358 3.65039 8.24131 3.65039 7.90547ZM3.65039 11.9595C3.65039 11.6237 3.92265 11.3514 4.2585 11.3514H7.50178C7.83762 11.3514 8.10989 11.6237 8.10989 11.9595C8.10989 12.2954 7.83762 12.5676 7.50178 12.5676H4.2585C3.92265 12.5676 3.65039 12.2954 3.65039 11.9595Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsActive);
export default __webpack_public_path__ + "static/media/tickets-active.72d1608d1d05e1e3aee9256f7fef75f0.svg";
export { ForwardRef as ReactComponent };